//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get } from 'vuex-pathify';

export default {
  name: 'TranMemberListDialog',
  props: ["show_status"],
  data () {
    return {
      loading: false,
      total_record: 0,
      total_page: 1,
      findBy:  {label: 'รหัสสมาชิก', value: 'mcode' },
      options: [
        {label: 'รหัสสมาชิก', value: 'mcode' },
        {label: 'ชื่อสมาชิก', value: 'name_t' },
      ],
      rowsPerFetch: 200,
      pagination: {
        rowsPerPage: 0
      },
      pageID: 1,
      findWord: '',
      //current_row: 1,
      datalist: [],
      selected: [],
      columns: [
        { name: 'rownum', align: 'center', label: 'ลำดับ', field: 'rownum' },
        { name: 'mcode', align: 'center', label: 'รหัสสมาชิก', field: 'mcode'},
        { name: 'name_t', align: 'left', label: 'ชื่อสมาชิก', field: 'name_t'},
        { name: 'mdate',  align: 'center', label: 'วันที่สมัคร', field: 'mdate' }
      ],
      /* 
      customDialogModel: false,
      name: ''
      */
      fixed: false
    }
  },
  methods: {
    previous_page: function() {
      if (parseInt(this.pageID) > 1) {
        this.pageID = parseInt(this.pageID) - 1;
      }
    },
    next_page: function() {
      if (parseInt(this.pageID) < parseInt(this.total_page)) {
        this.pageID = parseInt(this.pageID) + 1;
      }
    },
    requestRowClick: function(selected_mcode, selected_row) {
        //this.current_row = selected_row.rownum;
        //console.log("row click :" + selected_mcode);
        if (this.selected.mcode !== selected_mcode) {
          this.selected.splice(0,1);
          this.selected.push(selected_row);
          this.$emit("onSeleted", selected_row);
        }
    },
    fetchDataList: function () {
      let self = this;
      self.loading = true;
      const params = new URLSearchParams();
      params.append('pageSize', this.rowsPerFetch);
      params.append('pageID', this.pageID);
      params.append('findBy', this.findBy.value);
      params.append('findWord', this.findWord);
      params.append('mcode', this.session_mcode);
      self.axios({
        method: 'post',
        headers: {
          'Authorization': self.jwt_token
        },        
        timeout: 0, // Let's say you want to wait at least unlimit mins
        url: self.url_api + 'MemberClient/Member.List.JSON.aspx',
        data: params
      })
      .then(function (response) {
        //console.log("response data");
        //console.log("result :" + response.data);
        let responseDoc = new DOMParser().parseFromString(response.data, 'text/xml');
       
        self.datalist = JSON.parse(responseDoc.getElementsByTagName('json')[0].textContent);
        self.selected = [];
        //self.selected = JSON.parse(responseDoc.getElementsByTagName('json')[0].textContent).slice(0, 1);
        //self.current_row = self.selected[0].rownum;
        self.total_record = responseDoc.getElementsByTagName('recordcount')[0].textContent;
        self.total_page = parseInt(responseDoc.getElementsByTagName('pagecount')[0].textContent);
        self.loading = false;
      })
      .catch(function (error) {
          console.log("Error :" + error.toString());
          self.loading = false;
      });
    }, 
    onHide() {
      //console.log("onHide");
      this.datalist = [];
      this.selected = [];
      this.total_record = 0;
      this.total_page = 1;
      this.findWord = "";
      this.$emit("onHide", "");
      //this.$parent.scode_dialog_show = false;
    }
    /*
    ,
    // when props.ok() gets called
    onOk (data) { },

    // when props.cancel() gets called
    onCancel () { },

    // when we show it to the user
    onShow () { },

    // when it gets hidden
    onHide () { },

    // custom handler
    async choose (okFn, hero) {
      if (this.name.length === 0) {
        this.$q.dialog({
          title: 'Please specify your name!',
          message: `Can't buy tickets without knowing your name.`
        })
      }
      else {
        await okFn()
        this.$q.notify(`Ok ${this.name}, going with ${hero}`)
      }
    }
    */
  },
  mounted () {
      //this.fetchDataList();
  },
  watch: {
    show_status: function () {
      //console.log("fixed :" + this.fixed);
      this.fixed = this.show_status;
      /*
       if (this.show_status) {
        this.selected.splice(0,1);
      }
      */
    },
    pageID: function () {
      this.fetchDataList();
    }
  },
  computed: {
      url_api: get('URL_API_PATH'),
      jwt_token: get('JWT_TOKEN'),
      session_mcode: get('SESSION_MCODE_LOGIN'),
  }
 
}
